module.exports = __webpack_public_path__ + "static/media/07.0bf48575.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/07.jpg
// module id = 466
// module chunks = 0